import { render } from "./YoutubeTag.vue?vue&type=template&id=6b19167a"
import script from "./YoutubeTag.vue?vue&type=script&lang=js"
export * from "./YoutubeTag.vue?vue&type=script&lang=js"

import "./YoutubeTag.vue?vue&type=style&index=0&id=6b19167a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__